import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {OrgDto} from "../dto/org.dto";
import {UrlBuilder} from "../item/url.item";
import {Observable, tap} from "rxjs";
import {SearchRequest} from "../dto/search/search-table.dto.req";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {SearchMediaRes} from "../dto/search/search-media.res";
import {DeletionProtection} from "../../libs/enum/deletion-protection.enum";
import {Belong} from "../../libs/enum/belong.enum";
import {MediaDto} from "../dto/media.dto";
import {isTrue} from "../../libs/utils/epic.utils";

@Injectable({providedIn: 'root'})
export class MediaRepo {

  private readonly mediaContentRead = '/v1/org/{orgId}/media/{mediaId}';
  private readonly mediaSearch = '/v1/org/{orgId}/media/search';
  private readonly mediaFileUpload = '/v1/org/{orgId}/media/upload/file';

  private readonly http: HttpClient = inject(HttpClient);

  public loadContent(org: OrgDto, mediaId: string): Observable<HttpResponse<Blob>> {
    const url = UrlBuilder.builder().addPath(this.mediaContentRead)
      .addParam('orgId', org.id).addParam('mediaId', mediaId)
      .setHttpHeader('Accept', '*/*').deleteHttpHeader('Content-Type').build();
    return this.http.get(url.getUrl(), {responseType: 'blob', observe: 'response', headers: url.getHeaders()});
  }

  public search(org: OrgDto, request: SearchRequest): Observable<WrapperDto<SearchMediaRes>> {
    const url = UrlBuilder.builder().addPath(this.mediaSearch).addParam('orgId', org.id).build();
    return this.http.post<WrapperDto<SearchMediaRes>>(url.getUrl(), request, url.getOptions()).pipe(
      tap((res) => res.dataType = res.dataType === 'SearchResultDto' ? 'SearchMediaRes' : res.dataType),
      map((res) => new WrapperDto(res))
    );
  }

  public fileUpload(org: OrgDto, parentId: string, parentType: Belong, tags: string, deletionProtection: DeletionProtection, attachment: boolean, file: File): Observable<WrapperDto<MediaDto>> {
    const data = new FormData();
    data.append('parentId', parentId);
    data.append('parentType', parentType);
    data.append('tags', tags);
    data.append('deletionProtection', deletionProtection);
    data.append('attachment', isTrue(attachment) ? 'true' : 'false');
    data.append('media', file);
    const url = UrlBuilder.builder().addPath(this.mediaFileUpload).addParam('orgId', org.id)
      .setContentTypeMultipartFormData().build();
    return this.http.post<WrapperDto<MediaDto>>(url.getUrl(), data, url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
